import classnames from 'classnames';

import './textarea.scss';

function Textarea({
  name,
  valid,
  validationText = 'This field is required!',
  value,
  label,
  className,
  placeholder,
  disabled = false,
  onChange,
}) {
  const wrapperClasses = classnames('input-group', {
    error: !valid,
    [className]: className,
  });

  return (
    <div className={wrapperClasses}>
      <label>{label}</label>
      <textarea
        name={name}
        className={className}
        placeholder={placeholder}
        disabled={disabled}
        value={value || ''}
        onChange={onChange}
      />
      {!valid && <span className="error">{validationText}</span>}
    </div>
  );
}

export default Textarea;
